import jwt from 'jsonwebtoken';
import { auth, isProduction2 } from '../../config';
import fs from 'fs';
import rasha from 'rasha';
import logger, { trace } from '../../logger';

export const defaultExpiration = 60 * 60 * 24 * 60; // 60 days

function buildOptions(user, expiration) {
  const baseOptions = {
    issuer: 'Yoodlize Inc',
    audience: 'yoodlize.com',
    expiresIn: expiration,
    algorithm: 'RS256',
  };
  if (user) {
    baseOptions.subject = user.id;
  }
  return baseOptions;
}

export async function jwk(req, res, next) {
  const jwk = {
    ...rasha.importSync({ pem: auth.jwt.publicKey }),
    alg: 'RS256',
    use: 'sig',
    kid: auth.jwt.publicKey,
  };
  const jwks = {
    keys: [jwk],
  };
  trace('jwt')('getting jwk');
  res.setHeader('Content-Type', 'application/json');
  res.send(JSON.stringify(jwks, null, 2) + '\n');
}

export function signJWT(user, expiresIn = defaultExpiration, additionalPayload) {
  if (!user) {
    console.log('jwtUtils - no user', user);
    return null;
  }
  const payload = Object.assign(
    {},
    {
      id: user.id,
      'https://hasura.io/jwt/claims': {
        'x-hasura-allowed-roles': ['admin', 'user'],
        'x-hasura-default-role': 'user',
        'X-Hasura-User-Id': user.id,
      },
    },
    additionalPayload
  );

  if (user.isAdmin || user.admin) {
    payload.admin = true;
  }
  // console.log('payload', payload);
  let token;
  try {
    token = jwt.sign(payload, auth.jwt.privateKey, buildOptions(user, expiresIn));
  } catch (err) {
    console.log('JWT construction error', err);
  }
  trace('jwt')(`token built:  ${token}`);
  return token;
}

export function signAnonJWT() {
  const expiresIn = 10000; // 10 seconds
  const payload = Object.assign(
    {},
    {
      'https://hasura.io/jwt/claims': {
        'x-hasura-allowed-roles': ['anonymous'],
        'x-hasura-default-role': 'anonymous',
      },
    }
  );

  // console.log('payload', payload);
  let token;
  try {
    token = jwt.sign(payload, auth.jwt.privateKey, buildOptions(null, expiresIn));
  } catch (err) {
    console.log('JWT construction error', err);
  }
  trace('jwt')(`anon token built:  ${token}`);
  return token;
}

/*  Hasura Config
{
  "type": "RS512",
  "key": "-----BEGIN PUBLIC KEY-----\nMFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAPNtfUwXmhBZUGiaYuK/zAyhhS+ANcSw\noVLXSd7YocTqmBnOiS1HI6HjTBxk2OnUmH388VWHWwGEejEXFYIL4VECAwEAAQ==\n-----END PUBLIC KEY-----\n",
  "claims_format": "json",
  "audience": "yoodlize.com",
  "issuer": "Yoodlize Inc"
}


*/

/*
--jwk
{
  "type": "RS256",
  "jwk_url": "https://alpha.yoodlize.com/api/auth/jwt/jwks",
  "audience": "yoodlize.com",
  "issuer": "Yoodlize Inc"
}
*/



// WEBPACK FOOTER //
// ./src/core/auth/jwtUtils.js